import React, { useEffect } from 'react'
import {Nav, Tab} from 'react-bootstrap';
import PricingSheetStructure from './PricingSheetStructure/PricingSheetStructure';
import PricingTemplate from './PricingTemplate/PricingTemplate';
import './AdminPricingSettings.scss'
import { SelectedStructure } from '../../../models/AdminSettingsM/AdminPricingSettingsModel';

interface Iprops{
  message:Function;
  selectedPricingHandler:Function;
  setTab:boolean;
  selectedpricingStructure?:SelectedStructure;
  editHandler:Function;
}

const SelectedPricingStructure = (props:Iprops) => {
  const {selectedPricingHandler,editHandler,setTab,selectedpricingStructure,message} = props

  return(
    <div className="selectedPricing">
      <Tab.Container defaultActiveKey={`${setTab ? "pricingSheetStructure":"pricingTemplates" }`}>
        <Nav variant="underline">
          <Nav.Item>
            <Nav.Link eventKey="pricingSheetStructure">Pricing Sheet Structure</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="pricingTemplates">Pricing Templates</Nav.Link>
          </Nav.Item>
        </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="pricingSheetStructure">
          <PricingSheetStructure />
        </Tab.Pane>
        <Tab.Pane eventKey="pricingTemplates">
          <PricingTemplate message = {message} pricingTemplateHandler={selectedPricingHandler} editHandler= {editHandler} selectedpricingStructure={selectedpricingStructure}/>
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
  )
}

export default SelectedPricingStructure